import { render } from "./DetailPro.vue?vue&type=template&id=6af6bdde&scoped=true"
import script from "./DetailPro.vue?vue&type=script&lang=js"
export * from "./DetailPro.vue?vue&type=script&lang=js"

import "./DetailPro.vue?vue&type=style&index=0&id=6af6bdde&scoped=true&lang=css"

import exportComponent from "C:\\Users\\acer1\\Desktop\\TTT-Member\\Partner\\GOODLUCK711\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af6bdde"]])

export default __exports__